import React, { useState } from 'react';
import globalStyles from '../../utils/globalStyles';
import { Box, Typography, MenuItem, Select, TableContainer, Table, TableHead, Paper, TableBody, TableRow, Snackbar, Alert, Button, TableCell, Divider, Card, CardContent } from '@mui/material';
import CodConfiguration from './codConfiguration';
import TamaraConfiguration from './TamaraConfiguration';
import TabbyConfiguration from './TabbyConfiguration';
import { StyledTableCell, StyledTableRow } from '../../utils/custiomStyle';
import EditIcon from '@mui/icons-material/Edit';
import axios from 'axios';
import legolasApi from '../../api/legolas';
import NextdayConfiguration from './NextdayConfiguration';
import StorePickUpConfiguration from './StorePickUpConfiguration';
import ChannelDropDownMenu from '../common/ChannelDropDownMenu'
import { useParams, useNavigate, useLocation } from "react-router-dom"

function PaymentConfiguration() {
  const formField = {
    enablePaymentFee: '',
    feelabelen: '',
    feevalue: '',
    minpayment: '',
    feetype: '',
    feelabelar: '',
    countryname: '',
    maxpayment: '',
    errormsgen: '',
    errormsgar: '',
    enableFreeDelivery: '',
    freeDeliveryMinAmount: ''
  };
  const [paymentMethod, setPaymnetMethod] = React.useState(0);
  const [dataList, setDataList] = React.useState([]);
  const [isEditMode, setIsEditMode] = React.useState(false);
  const [formData, setFormData] = React.useState(formField);
  const [open, setOpen] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openError, setOpenError] = React.useState(false);
  const [error, setError] = React.useState('');
  const localStorageUser = localStorage.getItem('user');
  const user = JSON.parse(localStorageUser);
  const userChannels = Array.isArray(user?.channel) ? user.channel.map(String) : [];
  const [channelData, setChannelData] = React.useState([]);
  const [selectedChannel, setSelectedChannel] = React.useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (location.key !== "default") {
      navigate(-1); // go previous page
    } else {
      navigate("/"); // dashboard
    }
  };
  // const getChannel = () => {
  //     axios.get(`${legolasApi.url}/admin/channel/list`)
  //         .then((res) => {
  //             console.log('order res: ', res.data.data);
  //             const allChannels = res.data.data;
  //             const filteredChannels = allChannels.filter(ch => userChannels.includes(ch._id));
  //             setChannelData(filteredChannels);
  //             //setChannelData(res.data.data);
  //         })
  //         .catch((error) => console.log('Error in getting orders: ', error));
  // }
  const getChannel = () => {
    axios.get(`${legolasApi.url}/admin/channel/list`)
      .then((res) => {

        const allChannels = res.data.data;

        const filteredChannels = allChannels.filter(ch =>
          userChannels.includes(ch._id)
        );

        setChannelData(filteredChannels);

        const shababunaChannelId =
          process.env.REACT_APP_SHABABUNA_CHANNEL_ID || "657979c059be05f5f8dd41f6";

        const defaultChannel =
          filteredChannels.find(ch => ch._id === shababunaChannelId)?._id
          || filteredChannels?.[0]?._id;

        setSelectedChannel(defaultChannel);
        getListData(defaultChannel);

      })
      .catch((error) =>
        console.log('Error in getting orders: ', error)
      );
  };
  const handleFilters = (key, channelId) => {
    setSelectedChannel(channelId);
    getListData(channelId);
  };

    function extractString(data) {
        const jsonString = data
        const jsonObject = JSON.parse(jsonString);
        const enSaValue = jsonObject['en-SA'];
        return enSaValue
    };
    const handleEditClick = (data) => {
        setPaymnetMethod(data.payment_id);
        console.log("data",data);
        console.log("EDIT DATA", data);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const feelabelObject = JSON.parse(data.fee_label)
        const enSaValue1 = feelabelObject['en-SA'];
        const errormsgObject = JSON.parse(data.error_message)
        setIsEditMode(true);
        setFormData({
            id: data.id,
            enablePaymentFee: data.enable_payment_fee,
            feelabelen: feelabelObject['en-SA'],
            feevalue: data.fee_value,
            minpayment: data.min_cart_total,
            feetype: data.fee_type,
            feelabelar: feelabelObject['ar-SA'],
            countryname: data.country_id,
            maxpayment: data.max_cart_total,
            errormsgen: errormsgObject['en-SA'],
            errormsgar: errormsgObject['ar-SA'],
            enableFreeDelivery: Number(data.enable_delivery_fee ?? data.enableFreeDelivery ?? 0),
            freeDeliveryMinAmount: data.free_delivery_min_amount ? Number(data.free_delivery_min_amount): ''      
          });
    };

    console.log("formdataIsEdit", formData.countryname);
    const handleForm =(e)=>{
        const targetValue = e.target.value
        console.log("targetvalue", targetValue)
        if(targetValue===1){
           setPaymnetMethod(targetValue)
           setFormData(formField)
        }else if(targetValue===5){
            setPaymnetMethod(targetValue)
            setFormData(formField)
        } else if(targetValue===6){
            setPaymnetMethod(targetValue)
            setFormData(formField)
        }else if(targetValue===7){
            setPaymnetMethod(targetValue)
            setFormData(formField)
        }else if(targetValue===3){
            setPaymnetMethod(targetValue)
            setFormData(formField)
        }else{
            setPaymnetMethod(false)
            setFormData(formField)
        }
    };
  
    const refreshPaymentMethod =() =>{
        setPaymnetMethod(0);
    };
    const getListData = (channelId) => {

        const finalChannelId = String(channelId || selectedChannel || userChannels[0]).replace(',', '');
        axios.get(`${legolasApi.url}/admin/payment/config/fetch?channelId=${finalChannelId}`).then(res => {
            setDataList(res.data.data)
            console.log('get listres', res.data.data)
        }).catch((error) => {
            console.log('Error in getting list', error)
        })
    };

    React.useEffect(() => {
        getChannel();
        if (userChannels.length) {
            setSelectedChannel(userChannels[0]);
            getListData(userChannels[0]);
        }
    }, []);



    const handleEditSuccessMsg = () => {
        setOpenEdit(true)
        setTimeout(() => {
            setOpenEdit(false)
        }, 3000)
    };

    const handleSuccessMsg = () => {
        setOpen(true)
           setTimeout(() => {
               setOpen(false)
           }, 3000)
       };

  const close = () => {
    setOpen(false)
    setOpenEdit(false)
    setOpenError(false)
  };

  const handleErrorMsg = (message) => {
    setError(message)
    setOpenError(true)
    setTimeout(() => {
      setError('')
      setOpenError(false)
    }, 3000)
  };
  
  return (
    <>
      <Box sx={{ maxWidth: "1200px", margin: "auto", marginTop: "110px", padding: "30px", background: "#fff", borderRadius: "8px", boxShadow: "0 2px 10px rgba(0,0,0,0.08)" }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "30px" }}>
          <Typography variant="h4" sx={{ fontWeight: 600, color: "#2b3f7a" }}>Payment Configuration</Typography>
          <Button variant="contained" sx={{ backgroundColor: "#2b3f7a" }} onClick={handleBack}>Back </Button>
        </Box>
        <Divider sx={{ marginBottom: "30px" }} />
        <Snackbar open={openError} autoHideDuration={3000} onClose={close} anchorOrigin={{ vertical: "top", horizontal: "right" }} sx={{ mt: "90px" }}>
          <Alert onClose={close} severity="error" sx={{ width: "400px" }}>{error} </Alert>
        </Snackbar>
        {isEditMode ? (
          <Snackbar open={openEdit} autoHideDuration={3000} onClose={close} anchorOrigin={{ vertical: "top", horizontal: "right" }} sx={{ mt: "90px" }} >
            <Alert onClose={close} severity="success" sx={{ width: "400px" }}> Payment configuration has been Updated successfully </Alert>
          </Snackbar>
        ) : (
          <Snackbar open={open} autoHideDuration={3000} onClose={close} anchorOrigin={{ vertical: "top", horizontal: "right" }} sx={{ mt: "90px" }} >
            <Alert onClose={close} severity="success" sx={{ width: "400px" }}> Payment configuration has been added successfully </Alert>
          </Snackbar>
        )}

        <Card sx={{ marginBottom: "30px" }}>
          <CardContent sx={{ display: "flex", gap: "30px", alignItems: "center" }}>
            {userChannels.length > 1 && (
              <ChannelDropDownMenu channelData={channelData} handleChannelFilter={handleFilters} selectedChannel={selectedChannel} />
            )}
            <Box>
              <Typography sx={{ marginBottom: "5px", fontWeight: 500 }}> Payment Method</Typography>
              <Select labelId="demo-select-small" id="demo-select-small" onChange={handleForm} value={paymentMethod} sx={{ width: "260px" }}>
                <MenuItem value={1}>Cod</MenuItem>
                <MenuItem value={5}>Tamara</MenuItem>
                <MenuItem value={6}>Tabby</MenuItem>
                <MenuItem value={7}>NextDay</MenuItem>
                <MenuItem value={3}>store pickup</MenuItem>
              </Select>
            </Box>
          </CardContent>
        </Card>
        {paymentMethod !== 0 && (
          <Card sx={{ marginBottom: "40px" }}>
            <CardContent>
              <Typography variant="h6" sx={{ marginBottom: "20px", fontWeight: 600 }}> Payment Configuration Form </Typography>
              {paymentMethod === 1 && (<CodConfiguration paymentMethod={paymentMethod} getListData={getListData} refreshPaymentMethod={refreshPaymentMethod}
                handleEditSuccessMsg={handleEditSuccessMsg} handleErrorMsg={handleErrorMsg} handleSuccessMsg={handleSuccessMsg} formData={isEditMode ? formData : null} isEditMode={isEditMode} channelId={selectedChannel} />
              )}
              {paymentMethod === 5 && (<TamaraConfiguration paymentMethod={paymentMethod} refreshPaymentMethod={refreshPaymentMethod} getListData={getListData} handleEditSuccessMsg={handleEditSuccessMsg}
                handleErrorMsg={handleErrorMsg} handleSuccessMsg={handleSuccessMsg} formData={isEditMode ? formData : null} isEditMode={isEditMode} channelId={selectedChannel} />
              )}
              {paymentMethod === 6 && (<TabbyConfiguration paymentMethod={paymentMethod} refreshPaymentMethod={refreshPaymentMethod} getListData={getListData}
                handleEditSuccessMsg={handleEditSuccessMsg} handleErrorMsg={handleErrorMsg} handleSuccessMsg={handleSuccessMsg} formData={isEditMode ? formData : null} isEditMode={isEditMode} channelId={selectedChannel} />
              )}
              {paymentMethod === 7 && (<NextdayConfiguration paymentMethod={paymentMethod} getListData={getListData} refreshPaymentMethod={refreshPaymentMethod}
                handleEditSuccessMsg={handleEditSuccessMsg} handleErrorMsg={handleErrorMsg} handleSuccessMsg={handleSuccessMsg} formData={isEditMode ? formData : null} isEditMode={isEditMode} channelId={selectedChannel} />
              )}
              {paymentMethod === 3 && (<StorePickUpConfiguration paymentMethod={paymentMethod} getListData={getListData} refreshPaymentMethod={refreshPaymentMethod}
                handleEditSuccessMsg={handleEditSuccessMsg} handleErrorMsg={handleErrorMsg} handleSuccessMsg={handleSuccessMsg} formData={isEditMode ? formData : null} isEditMode={isEditMode} channelId={selectedChannel} />
              )}
            </CardContent>
          </Card>
        )}
        <Card>
          <CardContent>
            <Typography variant="h6" sx={{ marginBottom: "15px", fontWeight: 600 }}> Existing Configurations</Typography>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead sx={{
                  backgroundColor: globalStyles.colors.backgroundPrimary,
                  "& .MuiTableCell-root": {
                    color: "#fff",
                    padding: "10px",
                    borderRight: "2px solid #fff"
                  }
                }}
                >
                  <TableRow>
                    <StyledTableCell align="center">ID</StyledTableCell>
                    <StyledTableCell align="center">Payment Type</StyledTableCell>
                    <StyledTableCell align="center">Country Name</StyledTableCell>
                    <StyledTableCell align="center">Fee Type</StyledTableCell>
                    <StyledTableCell align="center">Fee Label</StyledTableCell>
                    <StyledTableCell align="center">Fee Value</StyledTableCell>
                    <StyledTableCell align="center">Enable Payment Fee</StyledTableCell>
                    <StyledTableCell align="center">Min Payment</StyledTableCell>
                    <StyledTableCell align="center">Max Payment</StyledTableCell>
                    <StyledTableCell align="center">Action</StyledTableCell>
                  </TableRow>

                </TableHead>
                {dataList.length === 0 ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <Typography variant="h6">No Record Found</Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {dataList.map((data) => (
                      <StyledTableRow key={data.id}>
                        <StyledTableCell align="center">{data.id}</StyledTableCell>
                        <StyledTableCell align="center">
                          {data.payment_id === 5 ? "Tamara" : data.payment_id === 6 ? "Tabby" : data.payment_id === 7 ? "NextDay" : "COD"}
                        </StyledTableCell>
                        <StyledTableCell align="center">{extractString(data.country_name)}</StyledTableCell>
                        <StyledTableCell align="center">{data.fee_type}</StyledTableCell>
                        <StyledTableCell align="center">{extractString(data.fee_label)}</StyledTableCell>
                        <StyledTableCell align="center">{data.fee_value}</StyledTableCell>
                        <StyledTableCell align="center">{data.enable_payment_fee === 1 ? "Yes" : "No"}</StyledTableCell>
                        <StyledTableCell align="center">{data.min_cart_total}</StyledTableCell>
                        <StyledTableCell align="center">{data.max_cart_total}</StyledTableCell>
                        <StyledTableCell align="center"><EditIcon sx={{ cursor: "pointer", color: "#2b3f7a" }} onClick={() => handleEditClick(data)} />
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}


export default PaymentConfiguration;

